import { css } from "styled-components";
import token from "styled-token";
import { StyledIcon } from "../../components/Icon/Icon";
/** @class PaginationButtonMixin */

/** @method */

export var PaginationButtonMixin = token({
  radius: "radii.ellipse",
  size: "sizes.heights.md"
}, function (tokens) {
  return css(["border-radius:", ";height:", "px;width:", "px;display:flex;align-items:center;justify-content:center;padding:0;&,&:hover{text-decoration:none;}&[aria-pressed=\"true\"]:disabled{opacity:1;}", "{margin:0;}"], tokens.radius, tokens.size, tokens.size, StyledIcon);
});